/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetQuickcheckSettingsRequest
 */
export interface SetQuickcheckSettingsRequest {
    /**
     * Allowed origin URL for the quickcheck portal (used for CORS and portal access).
     */
    origin: string;
    /**
     * URL to the privacy policy page shown to users in the quickcheck portal.
     */
    privacy: string;
    /**
     * Cloudflare Turnstile site key for this serviceprovider's quickcheck embed form. Public value.
     */
    turnstileSiteKey?: string;
    /**
     * Cloudflare Turnstile secret key used to verify tokens server-side. Omit to keep the currently stored key unchanged, or send an empty string to remove it and disable verification.
     */
    turnstileSecretKey?: string;
}

/**
 * Check if a given object implements the SetQuickcheckSettingsRequest interface.
 */
export function instanceOfSetQuickcheckSettingsRequest(value: object): value is SetQuickcheckSettingsRequest {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('privacy' in value) || value['privacy'] === undefined) return false;
    return true;
}

export function SetQuickcheckSettingsRequestFromJSON(json: any): SetQuickcheckSettingsRequest {
    return SetQuickcheckSettingsRequestFromJSONTyped(json, false);
}

export function SetQuickcheckSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetQuickcheckSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'origin': json['origin'],
        'privacy': json['privacy'],
        'turnstileSiteKey': json['turnstileSiteKey'] == null ? undefined : json['turnstileSiteKey'],
        'turnstileSecretKey': json['turnstileSecretKey'] == null ? undefined : json['turnstileSecretKey'],
    };
}

export function SetQuickcheckSettingsRequestToJSON(json: any): SetQuickcheckSettingsRequest {
    return SetQuickcheckSettingsRequestToJSONTyped(json, false);
}

export function SetQuickcheckSettingsRequestToJSONTyped(value?: SetQuickcheckSettingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'origin': value['origin'],
        'privacy': value['privacy'],
        'turnstileSiteKey': value['turnstileSiteKey'],
        'turnstileSecretKey': value['turnstileSecretKey'],
    };
}

